module.exports = __webpack_public_path__ + "static/media/linked-in.c834f8b7.svg";